import moment from 'moment';
import numeral from 'numeral';
import { fetchSortitionResult } from '../../../api/homepage.api.js';

export default {
	inject: ['contentStatus'],
	props: {
		upcomingSortition: {
			type: Object,
			required: true
		}
	},
	watch: {
		'upcomingSortition.sortition'(sortition) {
			clearInterval(this.currentTimeInterval);
			if (sortition) {
				this.currentTime = moment(sortition.serverTime);
				this.calculateTimeLeft(this.currentTime);
				this.currentTimeInterval = setInterval(() => {
					this.currentTime = this.currentTime.clone().add(1, 'second');
					this.calculateTimeLeft(this.currentTime);
				}, 1000);
			}
		}
	},
	methods: {
		async eagerFetchResult() {
			if (!this.fetchingResult) {
				try {
					this.fetchingResult = true;
					const response = await fetchSortitionResult(
						this.upcomingSortition.sortition.id
					);

					this.result = response.data.result;
				} catch (e) {
					console.error(e);
				} finally {
					this.fetchingResult = false;
				}
			}
		},
		async requestFetchResults() {
			try {
				this.eagerFetchResult();
			} catch (e) {
				console.error(e);
			}
		},
		calculateTimeLeft(time) {
			const sortitionTime = moment(this.upcomingSortition.sortition.time),
				timeLeftInSeconds = sortitionTime.diff(time, 'seconds');

			if (timeLeftInSeconds < 10 && this.result === null) {
				this.eagerFetchResult();
			}

			if (timeLeftInSeconds === 0) {
				if (this.result) {
					this.$root.$emit('sortition-time', this.result);
				}

				this.$emit('refresh');
			}

			this.timeLeft = numeral(timeLeftInSeconds).format('00:00:00');
		}
	},
	destroyed() {
		clearInterval(this.currentTimeInterval);
	},
	data() {
		return {
			currentTime: null,
			timeLeft: null,
			currentTimeInterval: null,
			result: null,
			fetchingResult: false
		};
	}
};
